<template>
    <button
        class="btn-option-phonemic-vowel"
        :class="selectionClass">
        <span class="btn-option-phonemic-vowel__text">{{ optionText }}</span>
    </button>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            featureType: { type: String, default: 'lorem' },
            optionSlug:  { type: String, default: 'lorem' },
            optionText:  { type: String, default: 'Lorem' },
        },

        computed: {
            selectionClass(){
                let answerDataFeaturevalue = this.$store.state.answerData.vowelFeatures[this.featureType];
                if(answerDataFeaturevalue === this.optionSlug){
                    return 'btn-option-phonemic-vowel--selected';
                }
            }
        },
    };
</script>

<style scoped src="@/css/components/btn-option-phonemic-vowel.css"></style>